export default {
  data() {
    return {
      siteUrl: "https://spice.u-web-nana.com",
      siteTitle: "クリエイティブ活動を便利にするツールのサイト SPICE"
    }
  }
}